import type { NotificationResponse } from '@/types/notification';
import { i18n } from '@/i18n';
import { formatDateTime } from '@/utils/format';

export function cleanNotificationText(text?: string | null): string {
  if (!text?.trim()) return '';

  return text
    .replace(/\s*·\s*(?:HR_[A-Z_]+\s*#?\d+|employee\s*#\d+)\b/gi, '')
    .replace(/\b(?:HR_[A-Z_]+|employee)\s*#\d+\b/gi, '')
    .replace(/\bHR_[A-Z_]+-\d+\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s·\s·\s/g, ' · ')
    .replace(/^\s*·\s*/g, '')
    .replace(/\s*·\s*$/g, '')
    .trim();
}

export function isNotificationUnread(notification: NotificationResponse): boolean {
  return notification.readFlag !== true;
}

export function formatNotificationTime(createdAt?: string): string {
  if (!createdAt) return '—';
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '—';

  const now = Date.now();
  const diffMs = now - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 45) {
    return i18n.t('time.justNow', { ns: 'notifications', defaultValue: 'Just now' });
  }
  if (diffMin < 60) {
    return i18n.t('time.minutesAgo', { ns: 'notifications', count: diffMin, defaultValue: `${diffMin}m ago` });
  }
  if (diffHour < 24) {
    return i18n.t('time.hoursAgo', { ns: 'notifications', count: diffHour, defaultValue: `${diffHour}h ago` });
  }
  if (diffDay === 1) {
    return i18n.t('time.yesterday', { ns: 'notifications', defaultValue: 'Yesterday' });
  }
  if (diffDay < 7) return `${diffDay}d ago`;

  return formatDateTime(createdAt);
}

export function countReadNotifications(items: NotificationResponse[]): number {
  return items.filter((n) => !isNotificationUnread(n)).length;
}
